import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styled from 'styled-components';

const ProgressBar = styled.div`
  left: 0;
  position: absolute;
  top: 50px;
  transition: width .2s;
  width: 100%;
  z-index: 1000000;


  @media (min-width: 769px) {
    top: 100px;
  }

  .image-progress-bar__bar {
    background-color: ${({ theme }) => theme.colors.primary };
    transform: translate3d(0, -20px, 0);
    transition: transform 2s;

    &.is-visible {
      transform: translate3d(0, 0, 0);
    }
  }
`;

const Bar = styled.div`
  transition: all .5s;
  minWidth: 30px;
  width: ${({ state }) => (state.loadedImages / state.totalImages) * 100 + '%' };
  height: 10px;
`;

class ImageProgressBar extends Component {

  state = {
    totalImages: this.props.photos.filter(photo => photo && photo.url !== '').length,
    loadedImages: 0,
    photos: this.props.photos.filter(photo => photo && photo.url !== '')
  };

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.photos.length !== this.props.photos.length) {
      const photos = this.props.photos.filter(photo => photo && photo.url !== '');
      this.setState(() => ({
        totalImages: photos.length,
        photos: photos
      }));
    }
    if (this.state.loadedImages === this.state.totalImages && this.state.totalImages !== 0) {
      setTimeout(() => { this.props.handleFinishLoading(); }, 1000);
    }
  }

  render() {

    const styles = ['image-progress-bar__bar', { 'is-visible': this.state.totalImages > 0 }];

    const incrementCounter = () => {
      this.setState(() => ({ loadedImages: this.state.loadedImages + 1 }))
    };

    return (
        <ProgressBar className="image-progress-bar">{
            this.state.photos && this.state.photos.map((photo, index) => {
            return photo.url && <img key={ index } onLoad={ incrementCounter } style={{width: '0', height: '0'}} src={photo.url} />
          })
        }
          <Bar state={ this.state } className={classnames(styles)} />
        </ProgressBar>
    );
  }
}

ImageProgressBar.propTypes = {
  totalImages: PropTypes.number,
  imageCount: PropTypes.number,
  handleFinishLoading: PropTypes.func,
};

export default ImageProgressBar



// WEBPACK FOOTER //
// ./src/components/ImageProgressBar/index.js